import { primitiveSockets } from '../components/Flow/Sockets/sockets'

export default function isSocketPrimitive(socket) {
  return Object.keys(primitiveSockets).find(primSocket => {
    return primitiveSockets[primSocket] === socket
  })
}
